module.exports = __webpack_public_path__ + "static/img/Kenti-myanmar.ffa5781.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/outreach/Kenti-myanmar.jpg
// module id = Gkfg
// module chunks = 0